import type { Locale } from '@seek/melways-sites';
import { Box } from 'braid-design-system';
import { observer } from 'mobx-react';
import type React from 'react';

import type { IProspect } from '../../../stores/JobApplicationStore/CandidateStore';

import ListItem from './ListItem';

import * as styles from './PreviousApplications.css';
interface Props {
  previousApplications: IProspect[];
  selectedPreviousApplication?: IProspect;
  selectPreviousApplication: (previousApplicationId: string) => void;
  locale: Locale;
}

const List: React.FC<Props> = ({
  previousApplications,
  selectedPreviousApplication,
  selectPreviousApplication,
  locale,
}) => (
  <Box marginRight="large" className={styles.list}>
    {previousApplications.map((previousApplication) => (
      <ListItem
        className={`${styles.divider} ${
          previousApplication === selectedPreviousApplication
            ? styles.dividerSelected
            : ''
        }`}
        key={previousApplication.id}
        previousApplication={previousApplication}
        selectedPreviousApplication={selectedPreviousApplication}
        selectPreviousApplication={selectPreviousApplication}
        locale={locale}
      />
    ))}
  </Box>
);

export default observer(List);
